/* global axios */

import ApiClient from './ApiClient';

class TaccWorkItemsAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getTasks(params = {}) {
    return axios.get(`${this.baseUrl()}/tacc_tasks`, { params });
  }

  getReminders(params = {}) {
    return axios.get(`${this.baseUrl()}/tacc_reminder_items`, { params });
  }
}

export default new TaccWorkItemsAPI();
